import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/attendance/requests/")({
  head: () => ({
    meta: [{ title: "考勤申请 · imiker CRM" }],
  })
});
